

// Lazy-loaded components for code splitting
const DocumentReadList = () => import(/* webpackChunkName: "document-read" */ "./pages/ListPage.vue");
const DocumentReadDetail = () => import(/* webpackChunkName: "document-read" */ "./pages/FormPage.vue");
const DocumentReadIndex = () => import(/* webpackChunkName: "document-read" */ "./pages/IndexPage.vue");
export default [
  {
    path: "/document_read",
    component: DocumentReadIndex,
    redirect: "/document_read/list",
    name: "document_read",
    children: [
      {
        path: "list",
        component: DocumentReadList,
        name: "document_read.list",
      },
      // {
      //   path: "create",
      //   component: DocumentReadDetail,
      //   name: "document_read.create",
      //   props: { create: true },
      // },
      // {
      //   path: "edit/:id",
      //   component: DocumentReadDetail,
      //   name: "document_read.edit",
      //   props: { create: false },
      // },
    ],
  },
];
